import {
	formatCellNumber,
	IFormatCellNumberOptions,
	noContentPlaceholder,
	tableDataFormattingSettings,
} from 'ufinet-web-functions'

export const formatNumberOrDefault = (value: number | null, options?: IFormatCellNumberOptions): string =>
	value ? formatCellNumber(value, options ?? tableDataFormattingSettings) : noContentPlaceholder
